import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Filter, Ban, ArrowRightLeft } from 'lucide-react';
import { VSLProtection } from './types';

interface Props {
  protections: VSLProtection[];
}

export function ProtectionStatsCards({ protections }: Props) {
  useLanguage();
  const activeRules = protections.reduce((acc, p) => {
    let n = 0;
    if (p.countries.length || p.regions.length) n++;
    if (p.utmEnabled && p.utmRules.length) n += p.utmRules.length;
    if (p.urlKeyEnabled) n++;
    if (p.tokenEnabled) n++;
    if (p.blockProxyVpn) n++;
    if (p.allowedDevices.length < 3) n++;
    return acc + n;
  }, 0);
  // Contadores reais do backend (tb_vsl_protection.blocked_count / redirect_count,
  // incrementados pelo middleware a cada bloqueio/redirect).
  const blocked = protections.reduce((acc, p) => acc + (p.blockedToday ?? 0), 0);
  const redirects = protections.reduce((acc, p) => acc + (p.redirects ?? 0), 0);

  const mainCards = [
    { title: translateInterfaceText("Regras ativas"), value: activeRules, sub: translateInterfaceText("Filtros configurados"), Icon: Filter },
    { title: translateInterfaceText("Bloqueios detectados"), value: blocked, sub: translateInterfaceText("Total de acessos bloqueados"), Icon: Ban },
    { title: translateInterfaceText("Redirecionamentos"), value: redirects, sub: translateInterfaceText("Usuários enviados para vídeo alternativo"), Icon: ArrowRightLeft },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {mainCards.map(({ title, value, sub, Icon }) => (
        <div
          key={title}
          className="bg-white border border-[#EEF2F7] rounded-2xl px-5 py-4 flex flex-col justify-between hover:border-[#CBD5E1] transition-colors"
        >
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[12px] text-[#64748B] font-bold uppercase tracking-wider">{title}</p>
              <p className="text-[28px] font-black text-[#111827] mt-1 leading-none tracking-tight">{value}</p>
            </div>
            <div className="w-9 h-9 rounded-xl bg-[#F8FAFC] flex items-center justify-center border border-[#F1F5F9]">
              <Icon className="w-[18px] h-[18px] text-[#64748B]" />
            </div>
          </div>
          <p className="text-[12px] text-[#94A3B8] mt-4 font-medium">{sub}</p>
        </div>
      ))}
    </div>
  );
}
